import axios from 'axios'
import { getUserToken, getCurrentUser } from './authService'

const API_DOMAIN = process.env.VUE_APP_YOUVENDO_API_SERVER
const API_VERSION = 'v1'

/*** Create a custom instance of axios ***/
const http = axios.create({
  baseURL: `${API_DOMAIN}/api/${API_VERSION}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
})

/*** Add interceptor to modify request config ***/
http.interceptors.request.use(async config => {
  const token = await getUserToken(config._forceTokenRefresh === true)
  config.headers = {
    ...config.headers,
    'x-auth-token': token
  }
  if (config.data instanceof FormData) {
    config.headers = {
      ...config.headers,
      'Content-Type': 'multipart/form-data'
    }
  }

  return config
})

/*** Add global error handling ***/
http.interceptors.response.use(null, async error => {
  if (!error.response) return Promise.reject(error)

  const { status } = error.response
  const originalRequest = error.config

  if (status === 401 && originalRequest && !originalRequest._retried) {
    originalRequest._retried = true
    originalRequest._forceTokenRefresh = true

    if (!getCurrentUser()) {
      redirectToLogin()
      return Promise.reject(error)
    }

    try {
      return await http.request(originalRequest)
    } catch (retryError) {
      if (retryError.response && retryError.response.status === 401) {
        redirectToLogin()
      }
      return Promise.reject(retryError)
    }
  }

  console.error('Unexpected Error:', error.response.data)
  return Promise.reject(error)
})

function redirectToLogin() {
  if (typeof window === 'undefined') return
  if (window.location.pathname === '/login') return
  const redirectUrl = window.location.pathname + window.location.search
  window.location.href = '/login?redirect_url=' + encodeURIComponent(redirectUrl)
}

export default {
  get: http.get,
  post: http.post,
  put: http.put,
  patch: http.patch,
  delete: http.delete
}
